import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Wrapper = styled.div`
  position: relative;
  box-sizing: border-box;
  margin-bottom: 32px;
  padding: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  outline: none;

  &::after {
    content: "";
    position: absolute;
    top: -1px;
    bottom: -1px;
    left: -1px;
    right: -1px;
    z-index: -1;
    border-radius: var(
      --box-wrapper-section-border-radius,
      var(--section-8px-border-radius, var(--8px))
    );
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
`;

export const SubContainerCode = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
`;

export const IconLayout = styled.div`
  display: flex;
  align-items: center;
  margin: 30px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

export const ButtonWrapper = styled.div`
  gap: 8px;
  margin-right: 24px;
  margin-bottom: 24px;
`;

export const InputContainer = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: row;
`;

export const Label = styled.label`
  display: block;
  color: ${props => (props.theme.name === "contrast" ? "#4A495E" : "#98a0ab")};
  font-size: 14px;
  line-height: 16px;
  ${semiBoldAlias()};
`;
